import { Component } from 'react'
import { API, Auth } from 'aws-amplify'
import config from './Config'

// TODO; update to admin service when added
const apiPath = config.apiGatewayProvider.PATH

class AdminClient extends Component {

    // Admin endpoints sit behind a Cognito User Pool authorizer and require the
    // caller's ID token (which carries the custom:role = 'ee-admin' claim). We call
    // them with a plain fetch + Bearer-style Authorization header rather than Amplify
    // API.post, because Amplify SigV4-signs the IAM-configured provider endpoint and
    // would overwrite our Authorization header.
    async adminPost(action, data) {
        const session = await Auth.currentSession()
        const token = session.getIdToken().getJwtToken()

        const response = await fetch(config.apiGatewayProvider.URL + 'admin/' + action, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: token
            },
            body: JSON.stringify(data)
        })
        return response.json()
    }

    async getProviders() {
        return API.post(apiPath, 'companies/list', {})
    }

    async getBrands() {
        return API.post(apiPath, 'products/brands', {})
    }

    async addBrand(brandName) {
        const data = {
            brandName
        }
        console.log(data)

        return API.post(apiPath, 'products/add-brand', {
            body: data
        })
    }

    async updateBrand(brandName, updates) {
        const data = {
            brandName,
            updates
        }
        console.log(data)

        return API.post(apiPath, 'products/update-brand', {
            body: data
        })
    }

    async updateBrandLogo(brandName, logoUrl) {
        const data = {
            brandName,
            logoUrl
        }
        console.log(data)

        return API.post(apiPath, 'products/update-brand-logo', {
            body: data
        })
    }

    async updateProfileSettings(companyId, name, url, slug, profileStatus, profileVerified, badgeLink, billingEnabled, metaDescription, planType, productsAvailable) {
        const data = {
            companyId,
            name,
            url,
            slug,
            profileStatus,
            profileVerified,
            badgeLink,
            billingEnabled,
            metaDescription,
            planType,
            productsAvailable
        }
        console.log(data)

        return API.post(apiPath, 'companies/update-settings', {
            body: data
        })
    }

    async sendAdminEmail(email, subject, body) {
        const data = {
            email,
            subject,
            body
        }
        console.log(data)

        return this.adminPost('admin-send-email', data)
    }

    async updateDeliverySettings(companyId, deliveryMethod, deliveryEmail, weeklyCap, leadPrice, deliveryStatus) {
        const data = {
            companyId,
            deliveryMethod,
            deliveryEmail,
            weeklyCap,
            leadPrice,
            deliveryStatus
        }
        console.log(data)

        return API.post(apiPath, 'companies/update-delivery-settings', {
            body: data
        })
    }

    async addProvider(name, url) {
        const data = {
            name,
            url
        }
        console.log(data)

        return this.adminPost('admin-add', data)
    }

    async createCardLink(companyId, leadStartDate, firstBillingDate, maxCap, email, pricePerLead) {
        const data = {
            companyId,
            leadStartDate,
            firstBillingDate,
            maxCap,
            email,
            pricePerLead
        }
        console.log(data)

        return this.adminPost('create-cardlink', data)
    }

    async getCardLink(companyId) {
        return this.adminPost('get-cardlink', { companyId })
    }

    async getUserStatus(email) {
        return this.adminPost('get-user-status', { email })
    }

    async sendLoginReminder(email, firstName, companyName) {
        const data = {
            email,
            firstName,
            companyName
        }
        console.log(data)

        return this.adminPost('send-login-reminder', data)
    }
} 

export default AdminClient